// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appsubtitle_subtitlelist
{
    width: 100%;
    height: 100%;
}

.appsubtitle_subtitlelist_top
{
    width: 100%;
    height: calc(100% - 20px);
}.appsubtitle_subtitlelist_bottom
{
    width: calc(100% - 12px);
    height: 17px;
    margin-top: 3px;
    margin-left: 6px;
    margin-left: 6px;
    background-color: #303030;
    border-radius: 3px;
    padding-left: 5px;
    text-align: left;
    font-size: 9px;
    padding-top: 2px;
    color: #e0e0e0;
    
}`, "",{"version":3,"sources":["webpack://./src/applications/appstyles/subtitle.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;AAC7B,CAAC;;IAEG,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,cAAc;;AAElB","sourcesContent":[".appsubtitle_subtitlelist\n{\n    width: 100%;\n    height: 100%;\n}\n\n.appsubtitle_subtitlelist_top\n{\n    width: 100%;\n    height: calc(100% - 20px);\n}.appsubtitle_subtitlelist_bottom\n{\n    width: calc(100% - 12px);\n    height: 17px;\n    margin-top: 3px;\n    margin-left: 6px;\n    margin-left: 6px;\n    background-color: #303030;\n    border-radius: 3px;\n    padding-left: 5px;\n    text-align: left;\n    font-size: 9px;\n    padding-top: 2px;\n    color: #e0e0e0;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
